const currentRepresentationKey = 'app.currentRepresentation';
export default currentRepresentationKey;
